import {
  EventType,
  PublicClientApplication,
  AuthenticationResult,
  CacheLookupPolicy,
} from "@azure/msal-browser";
import { msalConfig } from "authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const authResult = event.payload as AuthenticationResult;
    if (authResult.account) {
      msalInstance.setActiveAccount(authResult.account);
    }
  }
});

export const getMsalInstance = () => msalInstance;
export const getCachePolicyInstance = () => CacheLookupPolicy;
